import React from "react";
import { motion } from "framer-motion";

const P = {
  white: "#FFFFFF", snow: "#FAFAFA", pearl: "#F5F5F0", cloud: "#E8E5DE",
  silver: "#B0ADA6", steel: "#8A8780", graphite: "#5C5955", ink: "#1A1815",
  gold: "#C9A84C", success: "#2D8B5F", successBg: "#E8F5EE", error: "#C44D4D", warn: "#D4952B",
};
const serif = "'Playfair Display', Georgia, serif";
const GOLD_GRAD = "linear-gradient(135deg, #E8C96A, #C9A84C, #9A7A2E)";

export default function Radar() {
  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <h2 style={{ fontSize: 24, fontFamily: serif, fontWeight: 700, color: P.ink, marginBottom: 6 }}>Radar</h2>
        <p style={{ fontSize: 13, color: P.steel }}>Fraud detection and risk management powered by machine learning.</p>
      </div>

      {/* Risk overview */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 14, marginBottom: 32 }}>
        {[
          { label: "Risk Score",      val: "Low",   color: P.success, icon: "🛡️" },
          { label: "Blocked Today",   val: "0",     color: P.error,   icon: "🚫" },
          { label: "Reviews Pending", val: "0",     color: P.warn,    icon: "👁️" },
          { label: "Rules Active",    val: "12",    color: P.gold,    icon: "⚙️" },
        ].map((card, i) => (
          <motion.div key={i} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.08 }}
            style={{ background: P.white, borderRadius: 12, padding: "22px 20px", border: `1px solid ${P.cloud}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
              <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: "0.1em", color: P.steel, textTransform: "uppercase" as const }}>{card.label}</div>
              <span style={{ fontSize: 20 }}>{card.icon}</span>
            </div>
            <div style={{ fontSize: 28, fontFamily: serif, fontWeight: 700, color: card.color }}>{card.val}</div>
          </motion.div>
        ))}
      </div>

      {/* Rules */}
      <div style={{ background: P.white, borderRadius: 14, border: `1px solid ${P.cloud}`, overflow: "hidden" }}>
        <div style={{ padding: "20px 24px", borderBottom: `1px solid ${P.pearl}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: P.ink }}>Active Rules</div>
          <button style={{ padding: "8px 16px", borderRadius: 6, border: `1px solid ${P.cloud}`, background: P.white, fontSize: 11, fontWeight: 600, color: P.gold, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
            + Add Rule
          </button>
        </div>
        {["Block high-risk countries", "Velocity check: 5+ attempts/hour", "CVV mismatch block", "3DS required above €100", "IP geolocation mismatch"].map((rule, i) => (
          <div key={i} style={{ padding: "14px 24px", borderBottom: `1px solid ${P.pearl}`, display: "flex", justifyContent: "space-between", alignItems: "center", transition: "background .15s", cursor: "pointer" }}
            onMouseEnter={e => (e.currentTarget.style.background = P.snow)} onMouseLeave={e => (e.currentTarget.style.background = "transparent")}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: P.success }} />
              <span style={{ fontSize: 13, color: P.ink, fontWeight: 500 }}>{rule}</span>
            </div>
            <span style={{ fontSize: 10, color: P.success, fontWeight: 600, padding: "3px 8px", borderRadius: 4, background: P.successBg }}>Active</span>
          </div>
        ))}
      </div>
    </div>
  );
}